const PlayIcon = ({ color = '#7C3AED' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.3" />
    <path d="M6.7 5.6v4.8l3.8-2.4-3.8-2.4Z" fill={color} />
  </svg>
)

export default PlayIcon
